var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowlAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44591 2.2226C7.74034 1.9258 8.21771 1.9258 8.51214 2.2226L12 5.73853L15.4879 2.2226C15.7823 1.9258 16.2597 1.9258 16.5541 2.2226C16.8485 2.5194 16.8485 3.0006 16.5541 3.2974L13.0662 6.81333L17.0872 10.8667H21.0472C21.6024 10.8667 22.0589 11.323 21.9938 11.8787C21.9421 12.32 21.8578 12.7428 21.7465 13.1467H2.25347C2.14225 12.7428 2.05788 12.32 2.0062 11.8787C1.94111 11.323 2.39759 10.8667 2.95278 10.8667H6.9128L10.9338 6.81333L7.44591 3.2974C7.15148 3.0006 7.15148 2.5194 7.44591 2.2226ZM12 7.88814L9.04525 10.8667H14.9548L12 7.88814Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97901 21H16.021C16.5762 21 17.0262 20.5463 17.0262 19.9867V19.5996C17.0262 19.2158 17.2433 18.8691 17.5666 18.6663C18.6969 17.9569 20.2205 16.6042 21.1693 14.6667H2.83075C3.77954 16.6042 5.30312 17.9569 6.43342 18.6663C6.75666 18.8691 6.97376 19.2158 6.97376 19.5996V19.9867C6.97376 20.5463 7.42383 21 7.97901 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowlAlt);
export default __webpack_public_path__ + "static/media/bowl-alt.251ef802ade93d3e8612d41a21e37b08.svg";
export { ForwardRef as ReactComponent };